import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { OrganizationalUnitsHierarchy } from "@common/organizationalUnitsHierarchy";
import { Props } from "./types";
import styles from "./styles.scss";

function ParentSelection({ parent, select }: Props) {
  const { t } = useTranslation();
  const isSelected = ({ uuid }: Identifiable<OrganizationalUnit>) =>
    parent?.uuid === uuid;

  return (
    <SelectList
      rootClassName={styles.parentSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            <p>{parent ? parent.name : t("obsPage.creation.root")}</p>
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            <OrganizationalUnitsHierarchy
              isSelected={isSelected}
              select={(organizationalUnit) => s(select(organizationalUnit))}
            >
              <div
                className={classNames(styles.name, {
                  [styles.selected]: !parent,
                })}
                onClick={() => s(select(undefined))}
              >
                <p>{t("obsPage.creation.root")}</p>
              </div>
            </OrganizationalUnitsHierarchy>
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ParentSelection };
